export default __webpack_public_path__ + "images/addd3d9aaf441e473d12f93b4576a2e9-djdance_small.webp";